<template>
  <ClientOnly v-if="type === 'json' && animation">
    <Vue3Lottie :animation-data="animation" :loop :height="261" :width="273" />
  </ClientOnly>

  <CommonImage v-else class="w-[200px]" fetchpriority="high" :alt :src="link" />
</template>

<script setup lang="ts">
import { Vue3Lottie } from "vue3-lottie";
import CommonImage from "~/components/common/Atom/Image.vue";

const props = withDefaults(
  defineProps<{
    type?: "json" | "media";
    link?: string;
    alt?: string;
    loop?: boolean;
    animationData?: Record<string, any> | null;
  }>(),
  {
    type: "media",
    loop: false,
    animationData: null,
  },
);

const animation = ref<any>(props.animationData);

if (!animation.value && props.link && props.type === "json") {
  try {
    animation.value = await $fetch(props.link);
  } catch (error) {
    animation.value = null;
    console.error("Error fetching Lottie animation:", error);
  }
}
</script>
